<template>
  <dropdown-status
    :options="options"
    :current="current"
    :display-chevron="true"
    color="bg_color"
    @select="mSelect"
  />
</template>

<script>
import DropdownStatus from './DropdownStatus.vue'

export default {
  name: 'DropdownWorkStatus',
  components: {
    DropdownStatus
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    current: {
      type: [Object, String],
      required: true
    }
  },
  emits: ['select'],
  methods: {
    mSelect(payload) {
      this.$emit('select', payload)
    }
  }
}
</script>
